// extracted by mini-css-extract-plugin
export default {"base":"CompaniesTable_base__MGQbR","alternativeApplicantName":"CompaniesTable_alternativeApplicantName__nrgve"};